module.exports = __webpack_public_path__ + "img/ipad.5e70f317.jpg";